





import { Component } from 'vue-property-decorator';
import { RoleType, roles } from '@shared/common/types';
import BaseSelect from '@/modules/core/components/BaseSelect.vue';
import AuthenticationService from '@/auth.service';

@Component
export default class RoleSelect extends BaseSelect<{ id: RoleType; label: string }> {
  public async getOptions(): Promise<{ id: RoleType; label: string }[]> {
    const user = AuthenticationService.user;
    const allowedRoles = user ? user.getSelectableRoles() : [];
    this.options = Object.values(RoleType)
    .filter((role) => {
      if (allowedRoles && allowedRoles.length > 0) {
        return allowedRoles.includes(role);
      }

      return true;
    })
    .map((role: RoleType) => ({
      id: role,
      label: roles[role].label,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

    return this.options;
  }
}
